<template>
  <div class="sketch_parent">
    <div class="wrapper">
      <div class="sketch_main3">
        <div class="sketch_up_title3">送信完了</div>
      </div>
      <p>
        この度は、スケッチオーダーをご利用いただきありがとうございます。<br>
        送信完了メールを自動送信しました。<br>
        スタッフが対応してご連絡いたしますのでご連絡をお待ちください。<br>
        <br>
        対応可能時間は以下の通りです。<br>
        月〜金曜 10:00〜18:00 (定休：土日祝)<br>
        TEL: 03-6276-1123
      </p>
    </div>
    <div class="sketch_order_footer">
      <div class="sketch_order_next_btn" @click="close">閉じる</div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    close: function () {
      this.$router.push('/mmstyle/top')
    }
  },
  mounted: function () {
  },
  created: function () {
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>
<style src="../css/dc-sketch.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcSketchUploadComplete.vue